module.exports = __webpack_public_path__ + "static/media/news1.8b8f06ce.png";